export interface RegisterLeadsPayload {
    name: string;
    email: string;
    message: string;
    consentAccepted: boolean;
    captchaToken: string;
}

export default class RegisterLeadsEntity {
    constructor(
        public name: string,
        public email: string,
        public message: string,
        public captchaToken: string
    ) { }

    toJson(): RegisterLeadsPayload {
        return {
            name: this.name.trim(),
            email: this.email.trim(),
            message: this.message.trim(),
            consentAccepted: true,
            captchaToken: this.captchaToken,
        };
    }

    static fromJson(payload: RegisterLeadsPayload): RegisterLeadsEntity {
        return new RegisterLeadsEntity(
            payload.name, 
            payload.email, 
            payload.message,
            payload.captchaToken
        );
    }
}
